import { Routes } from '@angular/router';
import { HomeComponent } from './pages/home/home.component';
import { SheetComponent } from './pages/sheet/sheet.component';
import { DashboardComponent } from './pages/dashboard/dashboard.component';
import { authGuard } from './guards/auth.guard';
import { LoginComponent } from './auth/login/login.component';
import { SurveyComponent } from './pages/survey/survey.component';
import { ChatbotComponent } from './shared/chatbot/chatbot.component';
import { MapComponent } from './pages/map/map.component';
import { CategoriesComponent } from './pages/categories/categories.component';
import { LegalComponent } from './pages/legal/legal.component';
import { PrivacyComponent } from './pages/privacy/privacy.component';
import { CookiesComponent } from './pages/cookies/cookies.component';
import { AccommodationsComponent } from './pages/accommodations/accommodations.component';
import { AdminComponent } from './pages/admin/admin.component';
import { APP_ROUTES } from './constants/routes.constants';
import { CreateWonderComponent } from './pages/create-wonder/create-wonder.component';
import { GoodPracticesComponent } from './pages/good-practices/good-practices.component';

export const routes: Routes = [
    { path: APP_ROUTES.HOME, component: HomeComponent, pathMatch: 'full' },
    { path: `${APP_ROUTES.SHEET}/:id`, component: SheetComponent, pathMatch: 'full' },
    { path: APP_ROUTES.LOGIN, component: LoginComponent, pathMatch: 'full' },
    { path: APP_ROUTES.SURVEY, component: SurveyComponent, pathMatch: 'full' },
    { path: APP_ROUTES.CHATBOT, component: ChatbotComponent, pathMatch: 'full' },
    { path: APP_ROUTES.MAP, component: MapComponent, pathMatch: 'full' },
    { path: APP_ROUTES.WONDERS, component: CategoriesComponent, pathMatch: 'full' },
    { path: APP_ROUTES.LEGAL, component: LegalComponent, pathMatch: 'full' },
    { path: APP_ROUTES.PRIVACY, component: PrivacyComponent, pathMatch: 'full' },
    { path: APP_ROUTES.COOKIES, component: CookiesComponent, pathMatch: 'full' },
    { path: APP_ROUTES.GOOD_PRACTICES, component: GoodPracticesComponent, pathMatch: 'full' },
    { path: APP_ROUTES.ACCOMMODATIONS, component: AccommodationsComponent, pathMatch: 'full' },
    { path: APP_ROUTES.ADMIN, component: AdminComponent, pathMatch: 'full', canActivate: [authGuard] },
    { path: APP_ROUTES.DASHBOARD, component: DashboardComponent, pathMatch: 'full', canActivate: [authGuard] },
    { path: APP_ROUTES.CREATE_WONDER, component: CreateWonderComponent, pathMatch: 'full', canActivate: [authGuard] },


];
